import Client from "../../api/commonApi";


/*
  REACT_APP_API_ROUTE_ADMIN, REACT_APP_API_ROUTE_USER 문자열음 "/"붙여서 시작한다.
  Backend API에서 // 문자열을 인식하지 못하여서 URL 문자열 수정 적용
*/
const request_host = `${process.env.REACT_APP_API_ROUTE_ADMIN}`;
const request_host4user = `${process.env.REACT_APP_API_ROUTE_USER}`;
const route_member = process.env.REACT_APP_API_ROUTE_MEMBER;
const route_board_manager = process.env.REACT_APP_API_ROUTE_BOARD_MANAGER;
const route_board = process.env.REACT_APP_API_ROUTE_BOARD;
const route_board_reply = process.env.REACT_APP_API_ROUTE_BOARD_REPLY;
const route_board_comment = process.env.REACT_APP_API_ROUTE_BOARD_COMMENT;

/*
 사업자 등록번호 확인
 /company/regno, {"RegNo": "사업자 등록번호"}
*/
const postCompanyRegNo = async (postData) => {
  return Client.post(`${request_host4user}/company/regno`, postData);
};
/*
  Email Check
  /member/email_check, {"Email": "user@example.com"}
*/
const postMemberEmailCheck = async (postData) => {
  return Client.post(`${request_host4user}/member/email_check`, postData);
};
/*
  Member Detail 
  /member/detail, { "MemberId": "MemberId(UUID)" }
*/
const postMemberDetail = async (postData) => {
  return Client.post(`${request_host4user}/member/detail`, postData);
};
/* 
  member list
  /member/members, {"MemberName": "사용자명", "ApprovalYn": "string"}
*/
const postMembersList = async (postData) => {
  return Client.post(`${request_host4user}/member/members`, postData);
};
/*
  Member Approval
  /member/approval , { "MemberId": "사용자ID", "ApprovalYn": "Y"}
*/
const patchMemberApproval = async (email, approvalyn) => {
  return Client.patch(`${request_host4user}/member/approval`, {data: {"MemberId" : email, "ApprovalYn": approvalyn}});
};
/*
  Delete Member
  /dev/member, { "Email": "email@email.com" }
*/
const deleteMember = async (email) => {
  return Client.delete(`${request_host4user}/dev/member`, {data: {"Email" : email}});
};
/* 
  [admin] 사용자 승인 관련 (사용자===관리자)
  /admin/member/list
*/
const fetchMemberList = async (queryOptions) => {
    return await Client.post(`${request_host}/${route_member}/list`, queryOptions);
};
/* 
  [admin] 사용자 승인 관련 (사용자===관리자)
  /admin/member
*/
const putMemberItem = async (putData) => {
  return Client.put(`${request_host}/${route_member}`, putData);
};
/* 
  [admin] 사용자 승인 관련 
  input url, method get only
*/
const fetcher = async (url) => {
  return await Client.get(url);
};
/* 
  [admin] 사용자 승인 관련  
  input url, input method
*/
const fetcherUseMethod = async (url, options) => {
  const { method = 'POST', body } = options
  return await Client({
    url,
    method,
    data: body,
  });
};


/*
  [admin] 게시판 관련 - 게시판 Type 확인 (사용자===관리자)
  /admin/manage/type (post)
*/
const fetchBoardTypeList = async () => {
  return await Client.post(`${request_host}/${route_board_manager}/type`);
};
/*
  [admin] 게시판 관련 - 게시판 목록 확인 (사용자===관리자)
  /admin/manage/list (post)
*/
const fetchBoardManageList = async (queryOptions) => {
    return await Client.post(`${request_host}/${route_board_manager}/list`, queryOptions);
};
/*
  [admin] 게시판 관련 - 게시판 정보 확인 (사용자===관리자)
  /admin/manage/게시판ID  (get)
*/
const fetchBoardManageItem = async (manage_id) => {
  return Client.get(`${request_host}/${route_board_manager}/${manage_id}`, { manage_id });
};
/*
  [admin] 게시판 관련 - 게시판 정보 추가 (사용자===관리자)
  /admin/manage  (post)
*/
const postBoardManageItem = async (postData) => {
  return Client.post(`${request_host}/${route_board_manager}`, postData);
};
/*
  [admin] 게시판 관련 - 게시판 정보 수정 (사용자===관리자)
  /admin/manage  (put)
*/
const putBoardManageItem = async (putData) => {
  return Client.put(`${request_host}/${route_board_manager}`, putData);
};
/*
  [admin] 게시판 관련 - 게시판 정보 삭제 (사용자===관리자)
  /admin/manage  (delete)
*/
const deleteBoardManageItem = async (manage_id) => {
  return Client.delete(`${request_host}/${route_board_manager}`, {data: {"ManageId" : manage_id}});
};


/* 
  게시글 관련 - FAQ, BOARD 게시글 가져오기 (목록), (게시판 형식이 QnA가 아닌것)
  /admin/board/list (post)
*/
const fetchBoardList = async (queryOptions) => {
    return await Client.post(`${request_host}/${route_board}/list`, queryOptions);
};
/* 
  게시글 관련 - QnA 게시글 목록 가져오기 (목록), (게시판 형식이 QnA인것)
  /admin/board/qna (popst)
*/
const fetchBoardListQna = async (queryOptions) => {
    return await Client.post(`${request_host}/${route_board}/qna`, queryOptions);
};
/* 
  게시글 관련 - (게시판 형식 ==> QnA, Board) 게시판 하나의 게시글 목록을 자겨오기 (목록) (ManageId !== null, 필수)
  --> /board/list (post)
*/
const fetchBoardItemList = async (queryOptions) => {
  return await Client.post(`${request_host4user}/${route_board}/list`, queryOptions);
};
/* 
  게시글 관련 - (게시판 형식 ==> FAQ) 게시판 하나의 게시글 목록을 자겨오기 (목록) (ManageId !== null, 필수)
  --> /board/faq (post)
*/
const fetchBoardItemListFaq = async (queryOptions) => {
  return await Client.post(`${request_host4user}/${route_board}/faq`, queryOptions);
};
/* 
  게시글 관련 - 게시글 하나의 아이템 확인 (FAQ, QnA, Board → select one, ManageId !== null And BoardId !== null, 필수)
  /admin/board/게시판ID/게시글ID (get)
  --> /board/게시판ID/게시글ID (get) :: request_host --> request_host4user
*/
const fetchBoardItem = async (manage_id, board_id) => {
  return Client.get(`${request_host4user}/${route_board}/${manage_id}/${board_id}`, { manage_id, board_id });
};
/* 
  게시글 관련 - 게시글 등록 (FAQ, QnA, Board → select one)
  /admin/board (post)
  --> /board (post) :: request_host --> request_host4user
*/
const postBoardItem = async (postData) => {
  return Client.post(`${request_host4user}/${route_board}`, postData);
};
/* 
  게시글 관련 - 게시글 수정 (FAQ, QnA, Board → select one)
  /admin/board (put)
  --> /board (put) :: request_host --> request_host4user
*/
const putBoardItem = async (putData) => {
  return Client.put(`${request_host4user}/${route_board}`, putData);
};
/* 
  게시글 관련 - 게시글 삭제 (FAQ, QnA, Board → select one, 작성자===로그인사용자 Or 사용자===관리자)
  /admin/board (delete)
  --> /board (delete)
*/
const deleteBoardItem = async (board_id) => {
  return Client.delete(`${request_host4user}/${route_board}`, {data: {"BoardId" : board_id}});
};
/* 
  게시글 관련 - 게시글 답변 등록 (QnA → select one, 사용자===관리자)
  /admin/board (put)
*/
const putBoardReplyItem = async (putData) => {
  return Client.put(`${request_host}/${route_board_reply}`, putData);
};
/* 
  게시글 관련 - 게시글 답변  삭제 (QnA → select one, 사용자===관리자), (게시글 전체가 아닌 관리자 답변만 삭제 됨)
  /admin/board (delete)
*/
const deleteBoardReplayItem = async (board_id) => {
  return Client.delete(`${request_host}/${route_board_reply}`, {data: {"BoardId" : board_id}});
};



/*
  코멘트 관련 - 게시글 하나에 작성된 댓글 목록을 가져온다. (BoardId !== null, 필수)
  /board/comment/list (post)
*/
const fetchBoardCommentList = async (queryOptions) => {
  return await Client.post(`${request_host4user}/${route_board}/${route_board_comment}/list`, queryOptions);
};
/*
  코멘트 관련 - 게시글 하나에 작성된 댓글 목록을 가져온다. (BoardId !== null and comment_id !== null, 필수)
  삭제 및 수정 할 경우 작성자(CreatedBy) 정보 확인
  /board/comment/${BoardId}/${CommentId} (post)
*/
const fetchBoardCommentItem = async (board_id, comment_id) => {
  return Client.get(`${request_host4user}/${route_board}/${route_board_comment}/${board_id}/${comment_id}`, { board_id, comment_id });
};
/*
  코멘트 관련 - 게시글 하나에 작성된 댓글 등록
  /board/comment (post)
*/
const postBoardCommentItem = async (postData) => {
  return Client.post(`${request_host4user}/${route_board}/${route_board_comment}`, postData);
};
/*
  코멘트 관련 - 게시글 하나에 작성된 댓글 수정 (작성자===로그인사용자 Or 사용자===관리자)
  - 관리자가 수정하는 경우 내용을 "내용이 부적절하여 삭제처리 함" 변경할 때
  /board/comment (put)
*/
const putBoardCommentItem = async (putData) => {
  return Client.put(`${request_host4user}/${route_board}/${route_board_comment}`, putData);
};
/*
  코멘트 관련 - 게시글 하나에 작성된 댓글 삭제 (작성자===로그인사용자 Or 사용자===관리자)
  /board/comment (delete)
*/
const deleteBoardCommentItem = async (comment_id) => {
  return Client.delete(`${request_host4user}/${route_board}/${route_board_comment}`, {data: {"CommentId" : comment_id}});
};


export {
    postCompanyRegNo, postMemberEmailCheck, postMemberDetail,
    fetchMemberList, postMembersList, putMemberItem, fetcher, fetcherUseMethod, patchMemberApproval, deleteMember,
    fetchBoardList, fetchBoardListQna, fetchBoardItemList, fetchBoardItemListFaq, fetchBoardItem, postBoardItem, putBoardItem, deleteBoardItem, putBoardReplyItem, deleteBoardReplayItem,
    fetchBoardTypeList, fetchBoardManageList, fetchBoardManageItem, postBoardManageItem, putBoardManageItem, deleteBoardManageItem, 
    fetchBoardCommentList, fetchBoardCommentItem, postBoardCommentItem, putBoardCommentItem, deleteBoardCommentItem
};